import React from 'react';

const Person: React.VFC = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 3.74992C14.1041 3.74992 15.4166 5.06242 15.4166 6.66658C15.4166 8.27075 14.1041 9.58325 12.5 9.58325C10.8958 9.58325 9.58331 8.27075 9.58331 6.66658C9.58331 5.06242 10.8958 3.74992 12.5 3.74992ZM12.5 18.3333C16.4375 18.3333 20.9583 20.2145 21.25 21.2499H3.74998C4.0854 20.1999 8.57706 18.3333 12.5 18.3333ZM12.5 0.833252C9.27706 0.833252 6.66665 3.44367 6.66665 6.66658C6.66665 9.8895 9.27706 12.4999 12.5 12.4999C15.7229 12.4999 18.3333 9.8895 18.3333 6.66658C18.3333 3.44367 15.7229 0.833252 12.5 0.833252ZM12.5 15.4166C8.60623 15.4166 0.833313 17.3708 0.833313 21.2499V24.1666H24.1666V21.2499C24.1666 17.3708 16.3937 15.4166 12.5 15.4166Z" fill="#333333" />
  </svg>
);

export default Person;
